export const ONE_TRUST_SCRIPT_ID = 'onetrust-js';
export const initializeOneTrust = () => {
    const oneTrustScript = document.getElementById(ONE_TRUST_SCRIPT_ID);
    if (oneTrustScript) {
        const oneTrustScriptSrc = oneTrustScript === null || oneTrustScript === void 0 ? void 0 : oneTrustScript.dataset.src;
        if (oneTrustScriptSrc) {
            oneTrustScript.setAttribute('src', oneTrustScriptSrc);
        }
        else {
            // eslint-disable-next-line no-console
            console.warn('OneTrust script element not found');
        }
    }
    else {
        // eslint-disable-next-line no-console
        console.warn('OneTrust script src not found');
    }
};
export default initializeOneTrust;
